import { useTranslation } from 'react-i18next'
import styles from './ThemeRow.module.scss'

const ThemeRow = ({ theme, status, themeAss, setStatus }) => {
  const { t } = useTranslation('common')
  const STATUS_LABEL = {
    not_started: t('syllabus.status_not_started'),
    in_progress: t('syllabus.status_in_progress'),
    done: t('syllabus.status_done'),
    review: t('syllabus.status_review'),
  }
  return (
    <div className={styles.theme}>
      <div className={styles.themeMain}>
        <div className={styles.themeName}>{theme.name || theme.title}</div>
        <span className={`unv-badge ${styles.statusBadge} ${styles[`s_${status}`] || ''}`}>
          {STATUS_LABEL[status] || status}
        </span>
      </div>

      <div className={styles.themeActions}>
        <button
          className={`unv-btn ${status === 'in_progress' ? '' : 'unv-btn--ghost'}`}
          onClick={() => setStatus(theme, 'in_progress')}
        >
          {t('syllabus.doing_btn')}
        </button>
        <button
          className={`unv-btn ${status === 'done' ? '' : 'unv-btn--ghost'}`}
          onClick={() => setStatus(theme, 'done')}
        >
          {t('syllabus.done_btn')}
        </button>
        <button
          className={`unv-btn ${status === 'not_started' ? '' : 'unv-btn--ghost'}`}
          onClick={() => setStatus(theme, 'not_started')}
        >
          {t('syllabus.not_started_btn')}
        </button>
      </div>

      {theme.file && (
        <div className={styles.material}>
          <a className="unv-btn unv-btn--ghost" href={theme.file} target="_blank" rel="noreferrer">
            {t('syllabus.download_material')}
          </a>
        </div>
      )}

      {themeAss.length > 0 && (
        <div className={styles.assignments}>
          {themeAss.map((a) => (
            <div key={a.id} className={styles.assignmentCard}>
              <div className={styles.assignmentTitle}>{a.title}</div>
              <div className={styles.muted}>
                {t('syllabus.deadline_inline', {
                  value: a.due_at ? new Date(a.due_at).toLocaleDateString('ru-RU') : '—',
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ThemeRow
